// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bc035e5","455":"252402a0"}[chunkId] + ".chunk.js";
};